<template>
    <b-container class="os-card">
    <h3 class="text-center mb-5">{{ $helpers.getMetaTitleText($route) }}</h3>
  <b-form :class="{'container': !$uiHelpers.isMobile}" @submit.stop.prevent="signup">
    <loading-anim v-if="$store.state.loading" :active="$store.state.loading" fullScreen></loading-anim>
    <b-alert show variant="danger" v-if="form.state.submitted && form.state.unauthorized"><div v-html="submitError"></div></b-alert>
    <b-alert show variant="danger" v-if="form.state.submitted && form.state.errors">{{$t('signupOH.errors.general-code')}}
    </b-alert>
    <b-row>
        <b-col sm="12" xl="6" class="px-3">
    <b-form-group>
      <b-form-input :state="promotionCodeIsValid" type="text" v-model="form.codPromotion" v-on:change="callChecks()" :placeholder="$t('signupOH.registerCodeEntProf')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="promotionCodeIsValid">{{ $t('signupOH.errors.enterCode') }}</b-form-invalid-feedback>
    </b-form-group>
     <b-form-group>
            <!-- <base-multiSelect id="lang" v-model="this.formSelectLang.selected" label="text" :placeholder="$t('signupOH.selectLanguageTxt')" :options="this.formSelectLang.options"></base-multiSelect> -->
      <v-select id="lang" v-model="$v.form.selectedLangs.$model" attach :getOptionLabel="option => $i18nHelpers.normalizeProp('name') === 'name.es' ?option.name.es : option.name.en "
        multiple :placeholder="$t('signupOH.selectLanguageTxt')" :options="this.formSelectLang.options">
        <template #option="option">
                <slot name="option" :option="option">
                </slot>
              </template>
              <template #no-options>
                  {{ $t('signupOH.no-options') }}
              </template>
          <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
                  <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
                </svg>
            </span>
          </template>
    </v-select>
    <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('selectedLangs')">{{ $t('signupOH.errors.enterLang') }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group>
      <b-form-input type="text" v-model="$v.form.name.$model" :placeholder="$t('signupOH.registerName')" :state="validateState('name')"
        @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.name != null && form.name != ''">{{ $t('signupOH.errors.enterName') }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group>
      <b-form-input type="text" v-model="$v.form.firstSurname.$model" :placeholder="$t('signupOH.registerSurname1')" @input="resetForm()" :state="validateState('firstSurname')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.firstSurname != null && form.firstSurname != ''">{{ $t('signupOH.errors.enterSurname1') }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group>
      <b-form-input type="text" v-model="$v.form.secondSurname.$model" :placeholder="$t('signupOH.registerSurname2')" @input="resetForm()" :state="validateState('secondSurname')"></b-form-input>
    </b-form-group>
   <b-form-group v-if="!inOpenlegal()">
      <base-select id="speciality" :searchable="true" v-model="$v.form.specialityList.$model" :placeholder="$t('signupOH.specialty')" :options="selectedSpeciality.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="id" :errorMsg="$t('signupOH.errors.enterSpeciality')"/>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.specialityList != null">{{ $t('signupOH.errors.enterSpeciality') }}</b-form-invalid-feedback>
    </b-form-group>
    <div>
      <b-form-group v-if="searchIfMedical(form.specialityList).find(p => p !== undefined)">
      <b-form-input type="text" v-model="$v.form.collegeNumber.$model" :placeholder="$t('signupOH.registerCollegeNumber')" @input="resetForm()" :state="validateState('collegeNumber')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.collegeNumber != null && form.collegeNumber != ''">{{ $t('signupOH.errors.enterCollegeNumber') }}</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="form.trySubmit && !inOpenlegal() && (inMx || this.form.countryId === 28)" :state="maxValueCollegeNumber()">{{ $t('signupOH.errors.enterCollegeNumberMaxValue') }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-else>
      <b-form-input type="text" v-model="$v.form.collegeNumber.$model" :placeholder="$t('signupOH.registerCollegeNumber')" @input="resetForm()" :state="validateState('collegeNumber')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.collegeNumber != null && form.collegeNumber != ''">{{ $t('signupOH.errors.enterCollegeNumber') }}</b-form-invalid-feedback>
    </b-form-group>
    </div>

      <b-form-group>
      <b-form-input type="number" min="0" v-model="form.experienceProfessional" :placeholder="$t('signupOH.experienceProfessional')" @input="resetForm()" :state="validateState('experienceProfessional')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.experienceProfessional != null">{{ $t('signupOH.errors.enterExperienceProf') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="inMx">
      <b-form-input type="text" v-model="form.university" :placeholder="$t('signupOH.university')" @input="resetForm()"></b-form-input>
    </b-form-group>

    <b-form-group>
      <b-form-input type="text" v-model="form.urlProfessional" :placeholder="$t('signupOH.urlProfessional')" @input="resetForm()" :state="validateState('urlProfessional')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="(form.urlProfessional !== null && form.urlProfessional !== '' && form.urlProfessional !== undefined) ? validateUrl(form.urlProfessional) : true">{{ $t('signupOH.errors.urlProf') }}</b-form-invalid-feedback>
    </b-form-group>
    </b-col>
        <b-col sm="12" xl="6" class="px-3">

    <b-form-group>
     <div id="genderForm">
            <span class="genderText">{{ $t('signupOH.genderSex') }}</span>
            <radio-button-gender v-model="form.gender" :errorMsg="$t('signupOH.errors.enterSex')"></radio-button-gender>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.gender != null">{{ $t('signupOH.errors.enterSex') }}</b-form-invalid-feedback>
          </div>
    </b-form-group>

    
    <b-form-group>
            <base-select id="country" :searchable="true" v-model="$v.form.countryId.$model" :placeholder="$t('signupOH.country')" :options="selectedCountry.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="idCountry" v-on:change="reCallProvince()" :errorMsg="$t('signupOH.errors.enterCountry')"/>
            <!-- <base-select id="country" v-model="selectCountry.selected" :label="$i18nHelpers.normalizeProp('name')"
              :placeholder="$t('signupOH.country')" :options="selectCountry.options" valueProp="idCountry"></base-select> -->
      <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('countryId')">{{ $t('signupOH.errors.enterCountry') }}</b-form-invalid-feedback>
     </b-form-group>
<!-- 
    <b-form-group>
      <base-select id="province" :searchable="true" :clearable="clearable" ref="selectedProvince" v-model="selectProvince.selected" :placeholder="$t('signupOH.registerYourProvince')" :options="selectProvince.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="idState"></base-select>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="selectProvince.selected != null">{{ $t('signupOH.errors.enterProvince') }}</b-form-invalid-feedback>
    </b-form-group> -->
    <b-form-group>
            <v-select id="province" v-model="$v.form.stateId.$model" @input="selectIdProvince($event)" :clearable="false" attach :state="validateState('stateId')"
            :getOptionLabel="option => $i18nHelpers.normalizeProp('name') === 'name.es' ? option.name.es : option.name.en "  
            persistent-hint :placeholder="$t('signupOH.registerYourProvince')" valueProp="id" :options="this.selectProvince.options">
              <template #option="option">
                <slot name="option" :option="option">
                </slot>
              </template>
              <template #no-options>
                  {{ $t('signupOH.no-options') }}
              </template>
                <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
                  <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
                </svg>
            </span>
                </template>
            </v-select>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.stateId != null">{{ $t('signupOH.errors.enterProvince') }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
            <v-select id="provinceCollege" v-model="$v.form.stateIdCollege.$model" @input="selectIdProvinceCollege($event)" :clearable="false" 
            :getOptionLabel="option => $i18nHelpers.normalizeProp('name') === 'name.es' ?option.name.es : option.name.en" 
            persistent-hint :placeholder="$t('signupOH.collegeProvince')" 
            :options="this.selectProvince.options">
              <template #option="option">
                <slot name="option" :option="option">
                </slot>
              </template>
              <template #no-options>
                  {{ $t('signupOH.no-options') }}
              </template>
                <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
            <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
          </svg>
        </span>
      </template>
            </v-select>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.stateIdCollege != null">{{ $t('signupOH.errors.enterProvinceCollegiate') }}</b-form-invalid-feedback>
      </b-form-group>
<template>
      <b-form-group v-if="form.countryId === 28">
        <b-form-input type="text" v-model="form.nifnumber" :placeholder="$t('signupOH.indentitydocument')" @input="resetForm()"></b-form-input>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.nifnumber != null ? validateNIF(form.nifnumber) : false">
          {{ $t('signupOH.errors.enterIdentity') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group v-else>
        <b-form-input type="text" v-model="form.dni" :placeholder="$t('signupOH.indentitydocument')" @input="resetForm()"></b-form-input>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.dni != null">
          {{ $t('signupOH.errors.enterIdentity') }}
        </b-form-invalid-feedback>
      </b-form-group>

  <b-form-invalid-feedback v-if="form.trySubmit && dniregistered" :state="dniregistered !== true">
    {{ $t('signupOH.errors.duplicatedNIF') }}
  </b-form-invalid-feedback>
</template>

    <b-form-group>
      <b-form-input type="text" v-model="$v.form.email.$model" :placeholder="$t('signupOH.registerEmail')" @input="resetForm()" :state="validateState('email')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.email != null">{{ $t('signupOH.errors.enterEmail') }}</b-form-invalid-feedback>
    </b-form-group>
     
    <b-form-group>
      <b-form-input type="text" v-model="$v.form.emailConfirmation.$model" :placeholder="$t('signupOH.confirmEmail')" @input="resetForm()" :state="validateState('emailConfirmation')"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.emailConfirmation != null">{{ $t('signupOH.errors.enterConfirmEmail') }}</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.emailConfirmation == form.email">{{ $t('signupOH.errors.sameEmails') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-row class="align-items-center">
      <b-col sm="12" xl="5" class="pr-md-2 pr-0">
        <b-form-group>
          <base-select id="prefix" :searchable="true" v-model="$v.form.prefixCountry.$model" 
          :placeholder="$t('signupOH.registerPhonePrefix')" :options="selectPrefix.options" 
          :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="phonePrefix"/>
        </b-form-group>              
      </b-col>
      <b-col sm="12" xl="7">
        <b-form-group>
          <b-form-input type="number" v-model="form.phoneNumber" :placeholder="$t('signupOH.registerPhoneNumber')" @input="resetForm()" :state="validateState('phoneNumber')"></b-form-input>
          <b-form-invalid-feedback v-if="form.trySubmit" :state="form.phoneNumber != null">{{ $t('signupOH.errors.enterPhoneNumber') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group>
          <base-select id="discovery" :state="validateState('discoveryCheck')" :searchable="true" v-model="form.discoveryCheck" label="text" :placeholder="$t('signupOH.selectDiscovery')" :options="this.selectDiscovery.options"></base-select>
        </b-form-group>
        <base-checkbox v-model="form.termsAccepted">
            <span v-html="$t('signupOH.accept-terms')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('termsAccepted')">{{ $t('signupOH.errors.termsAccepted') }}</b-form-invalid-feedback>
          </base-checkbox>

          <base-checkbox v-model="form.privacyAccepted">
            <span v-html="$t('signupOH.accept-privacy')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('privacyAccepted')">{{ $t('signupOH.errors.privacyAccepted') }}</b-form-invalid-feedback>
          </base-checkbox>
          
          <base-checkbox v-model="form.dataVerification">
            <span v-html="$t('signupOH.data-verefication')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('dataVerification')">{{ $t('signupOH.errors.dataVerification') }}</b-form-invalid-feedback>
          </base-checkbox>
          <base-checkbox v-if="showCheckGroup" v-model="form.codeGroupCheck">
            <span class="checkbox-codegroup" v-on:click="() => visibleModalCodeGroup = true" v-html="$t('text-code-group-main')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.codeGroupCheck === true">{{ $t('signupOH.errors.dataVerification') }}</b-form-invalid-feedback>
          </base-checkbox>
          <!-- <vue-recaptcha sitekey="Your key here">
        </vue-recaptcha> -->
      </b-col>
      </b-row>
    <b-row class="align-items-center justify-content-center pb-3 text-center">
      <VueRecaptcha
      :sitekey="siteKey"
      :load-recaptcha-script="true"
      @verify="handleSuccess"
      @error="handleError"
      @expired="handleError"
    ></VueRecaptcha>
    <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('captcha')">{{ $t('signupOH.errors.captcha') }}</b-form-invalid-feedback>
    </b-row>

    <b-button type="submit" variant="primary" style="width: 100%">
      {{ $t('signupOH.signup-submit') }}
    </b-button>
    <hr>

    <span>{{ $t('signUp.already-registered') }}, <a style="cursor: pointer" class="log-in-a" @click="goLogin">{{ $t('sign-up-href') }}</a>.</span>
    <b-modal v-model="visibleModal" title-class="title-modal" centered no-close-on-esc no-close-on-backdrop hide-header-close :title="$t('signupOH.modalSuccessull')">
    <div class="text-center">
      <div style="margin-bottom:1rem">
      <h6 style="display: inline-block;margin-bottom: 0rem !important;">{{ $t('signupOH.modal1') }} </h6> <h6 style="color:#3238C4;margin-bottom: 0rem !important;display: inline-block">{{ form.email}}</h6><h6 style="display: inline-block" v-html="$t('signupOH.modal2')"></h6>
      </div>
      <div style="margin-bottom:1rem">
      <h6>{{ $t('signupOH.modal3') }}</h6>
      </div>
      <div style="margin-bottom:1rem">
      <h6 style="display: inline-block" v-html="$t('signupOH.modal4')"></h6>
      </div>
    </div>
    <template #modal-footer>
      <b-button :variant="okBtnVariant" @click="builtInOkFn()">
      {{ $t('signupOH.agree') }}      
      </b-button>
      <b-button v-if="cancelFn" :variant="cancelBtnVariant" @click="builtInCancelFn()">
        {{ cancelBtnText }}
      </b-button>
    </template>
  </b-modal>
  <b-modal v-if="dialogText" v-model="visibleModalCodeGroup" title-class="title-modal" centered no-close-on-esc no-close-on-backdrop hide-header-close>
        <div class="text-center">
          <div style="margin-bottom:1rem">
          <h6 style="margin-bottom: 0rem !important;">{{ $i18nHelpers.normalize(dialogText) }} </h6>
          </div>
        </div>
        <template #modal-footer>
          <b-button :variant="okBtnVariant" @click="() => visibleModalCodeGroup = false">
          {{ $t('signupOH.agree') }}      
          </b-button>
          <!-- <b-button :variant="cancelBtnVariant" @click="() => visibleModalCodeGroup = false">
          {{ $t('signupOH.cancel') }}      
          </b-button> -->
        </template>
  </b-modal>
  </b-form>
    </b-container>
</template>

<script>
import { BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormInput, BAlert, BModal } from 'bootstrap-vue'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import RadioButtonGender from '../base/forms/RadioButtonGender.vue'
import RadioButtonNieNif from '../base/forms/RadioButtonNieNif.vue'
import '@/plugins/vue-select'
import { required, requiredIf, minLength, numeric, email, sameAs } from 'vuelidate/lib/validators'
import { gender, phone, onlyTrue, onlyText } from '@/plugins/customValidators'
// import { VueRecaptcha } from 'vue-recaptcha'
import ReCaptcha from '../base/captcha/ReCaptcha.vue'
import { VueRecaptcha } from 'vue-recaptcha'
import LoadingAnim from '@/components/utils/LoadingAnim'
import accountMixin from '@/mixins/account.mixin'
import { recaptcha } from '@/constants/recaptcha'
import { SPAIN_COUNTRY_ID } from '@/constants/db/countries'
import geographyRepository from '@/repositories/GeographyRepository'
import languagesRepository from '@/repositories/LanguageRepository'
import specialtiesRepository from '@/repositories/SpecialitiesRepository'
import { inOpenlegal } from '@/constants/platformNames'
import CompaniesRepository from '@/repositories/CompaniesRepository'
import { validationsMixin } from '@/mixins/validations.mixin'
import { inMx, getDefaultCountryId, getDefaultPhonePrefix } from '@/helpers/global.helpers'

export default {
  name: 'professional-sign-up-form',
  mixins: [accountMixin, validationsMixin],
  components: {
    BForm,
    BModal,
    LoadingAnim,
    BFormGroup,
    // VueRecaptcha,
    BButton,
    ReCaptcha,
    VueRecaptcha,
    BFormInvalidFeedback,
    BFormInput,
    BAlert,
    'base-select': () => import('@/components/base/forms/BaseSelect'),
    'base-multiSelect': () => import('@/components/base/forms/BaseMultiSelect'),
    BaseCheckbox,
    'radio-button-gender': RadioButtonGender,
    'radio-button-nie-nif': RadioButtonNieNif
    },
  props: {
    callback: {
      type: Function,
      required: false
    },
    role: {
      type: String,
      required: false
    }
  },
  data () {
    return {
			inOpenlegal,
      siteKey: recaptcha,
      dniregistered: false,
      visibleModalCodeGroup: false,
      showCheckGroup: false,
      visibleModal: false,
      searchTerm: '',
      promotionCodeIsValid: null,
      searchLang: '',
      clearable: false,
      clean: false,
      form: {
        gender: this.$route.query.gender,
        trySubmit: false,
        selectedLangs: null,
        discoveryCheck: null,
        dni: null,
        codPromotion: this.$route.query.group,
        name: this.$route.query.name,
        firstSurname: this.$route.query.firstSurname,
        secondSurname: this.$route.query.secondSurname,
        nif: this.$route.query.nif,
        nifnumber: this.$route.query.nifnumber,
        email: this.$route.query.email,
        emailConfirmation: this.$route.query.emailConfirmation,
        collegeNumber: this.$route.query.collegeNumber,
        phoneNumber: this.$route.query.phoneNumber,
        experienceProfessional: this.$route.query.experienceProfessional,
        university: this.$route.query.university,
        urlProfessional: this.$route.query.urlProfessional,
        languages: this.$route.query.languages,
        countryId: null,
        stateId: null,
        stateIdCollege: null,
        prefixList: [],
        specialityList: null,
        prefixCountry: null,
        prefix: null,
        phonePrefix: this.$route.query.phonePrefix,
        termsAccepted: false,
        privacyAccepted: false,
        dataVerification: false,
        codeGroupCheck: false,
        captcha: false,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        }
      },
      formSelectLang: {
        options: [],
        optionsCopy: [],
        selected: null
      },
      binRadioGroup: {
        selected: null
      },
      selectedCountry: {
        selected: null,
        options: []
      },
      selectedSpeciality: {
        selected: null,
        options: []
      },
      selectProvince: {
        selected: null,
        selectedServer: null,
        options: []
      },
      selectProvinceCollege: {
        selected: null,
        selectedServer: null
      },
      selectDiscovery: {
        selected: null,
        options: [
          { value: '1', text: inOpenlegal() ? this.$t('signupDiscovery.title1-openlegal') : this.$t('signupDiscovery.title1') },
          { value: '2', text: inOpenlegal() ? this.$t('signupDiscovery.title2-openlegal') : this.$t('signupDiscovery.title2') },
          { value: '3', text: inOpenlegal() ? this.$t('signupDiscovery.title3-openlegal') : this.$t('signupDiscovery.title3') },
          { value: '4', text: this.$t('signupDiscovery.title4') },
          { value: '5', text: this.$t('signupDiscovery.title5') },
          { value: '6', text: 'Email' },
          { value: '7', text: this.$t('signupDiscovery.title7') },
          { value: '8', text: this.$t('signupDiscovery.title8') },
          { value: '9', text: this.$t('signupDiscovery.title9') },
          { value: '10', text: this.$t('signupDiscovery.title10') },
          { value: '11', text: this.$t('signupDiscovery.title11') }
        ]
      },
      selectPrefix: {
        selected: null,
        options: []
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null,
			dialogText: null
    }
  },
  validations: {
    form: {
      name: {
        required,
        onlyText,
        validateName () {
          return (!!this.form.name && this.form.name !== '' && this.validateText(this.form.name))
        }
      },
      selectedLangs: {
        required,
        minLength: minLength(1)
      },
      discoveryCheck: {
        required
      },
      firstSurname: {
        required,
        onlyText,
        validateFirstSurname () {
        return ((this.form.firstSurname != null && this.form.firstSurname !== '' && this.validateText(this.form.firstSurname)))
      }
      },
      secondSurname: {
        onlyText,
        validateSecondSurname () {
          return (this.form.secondSurname === null || this.form.secondSurname === '' || this.validateText(this.form.secondSurname))
        }
      },
      experienceProfessional: {
        required
      },
      urlProfessional: {
        validateUrl () {
          return this.form.urlProfessional === undefined || this.form.urlProfessional === null || this.form.urlProfessional === '' || this.validateUrl(this.form.urlProfessional)
        }
      },
      collegeNumber: {
        required,
        maxValueCollegeNumber () {
          return inMx ? (this.form.collegeNumber !== undefined && this.form.collegeNumber.toString().length >= 5)
          : (this.form.countryId !== SPAIN_COUNTRY_ID ? true : (this.searchIfMedical(this.form.specialityList).find(p => p !== undefined) && this.form.countryId === SPAIN_COUNTRY_ID) ? (this.form.collegeNumber === undefined ? false : this.form.collegeNumber.toString().length === 9) : true)
        }
        // maxLength () {
        //   return this.selectedSpeciality.selected.medical === true ? maxLength(9) : maxLength(40)
        // }
      },
      email: {
        required,
        email
      },
      emailConfirmation: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      gender: {
        required,
        gender
      },
      dni: {
        required,
        validateNIF () {
          return this.$validators.validatePersonalId(this.form.nifnumber, this.form.countryId)
        }
      },
      countryId: {
        required,
        numeric,
        validateCountry () {
          return (this.form.countryId != null && this.form.countryId !== '')
        }
      },
      specialityList: {
        required
      },
      stateId: {
        required,
        validateState () {
          return (this.form.stateId != null && this.form.stateId !== '')
        }
      },
      stateIdCollege: {
        required,
        validateState () {
          return (this.form.stateIdCollege != null && this.form.stateIdCollege !== '')
        }
      },
      prefixCountry: {
        required
      },
      phoneNumber: {
        required,
        phone
      },
      termsAccepted: {
        required,
        onlyTrue
      },
      privacyAccepted: {
        required,
        onlyTrue
      },
      dataVerification: {
        required,
        onlyTrue
      },
      captcha: {
        required,
        onlyTrue
      },
			codPromotion: {
        required: requiredIf(() => {
					return inOpenlegal()
				})
			}
    }
  },
  methods: {
    validateNIF (dni) {
    return this.$validators.validatePersonalId(dni, this.form.countryId)
    },
    validateText: function (text) {
            var re = /^[A-Za-zÀ-ÖØ-öø-ÿ\- ]+$/i
            if (!re.test(text)) {
                return false
            } else {
                return true
            }
    },
    selectIdProvince (e) {
      this.selectProvince.selectedServer = e.id
    },
    selectIdProvinceCollege (e) {
      this.selectProvinceCollege.selectedServer = e.name.es
    },
    callChecks: function () {
      CompaniesRepository.showGroupDialog(this.form.codPromotion).then((response) => {
        if (response.data !== '') {
          this.visibleModalCodeGroup = true
          this.showCheckGroup = true
          this.dialogText = response.data
        } else {
          this.visibleModalCodeGroup = false
          this.showCheckGroup = false
        }
      })
			if (!this.form.codPromotion) {
				this.promotionCodeIsValid = null
				return
      }
      if (this.form.codPromotion === '') {
        this.callSpecialties()
      } else {
        specialtiesRepository.getSpecialitiesByPromotionCode(this.form.codPromotion).then((response) => {
            if (response.data.length !== 0) {
              this.selectedSpeciality.options = null
              this.selectedSpeciality.options = response.data
              this.promotionCodeIsValid = true
            } else {
              this.promotionCodeIsValid = false
            }
        })
      }
    },
    callSpecialties: function () {
      specialtiesRepository.getSpecialities().then((response) => {
        this.selectedSpeciality.options = null
        this.selectedSpeciality.options = response.data
        if (this.$route.query.specialty && this.selectedSpeciality.options.length > 0) {
          const specialtyQuery = this.$route.query.specialty.toLowerCase()
          const matchingSpecialty = response.data.find(option => {
            const normalizedOptionName = this.$i18nHelpers.normalize(option.name).toLowerCase()
            return normalizedOptionName === specialtyQuery
          })
          if (matchingSpecialty) {
            this.form.specialityList = matchingSpecialty.id
          }
        }
    })
    },
    searchLanguages: function () {
      if (!this.searchLang) {
        this.formSelectLang.options = this.formSelectLang.optionsCopy
      }
      this.formSelectLang.options = this.formSelectLang.optionsCopy.filter(lang => {
        return lang.name.toLowerCase().indexOf(this.searchLang.toLowerCase()) > -1
      })
    },
    reCallProvince: async function () {
      await geographyRepository.getStatesByCountry(this.form.countryId).then((response) => {
        this.form.stateId = null
        this.selectProvince.selectedServer = null
        this.form.stateIdCollege = null
        this.selectProvinceCollege.selectedServer = null
        this.clearable = true
        this.selectProvince.options = response.data
    })
    this.checkQueryProvinces()
    },
    handleError: function () {
      this.form.captcha = false
      },
     handleSuccess: function () {
       this.form.captcha = true
      },
      maxValueCollegeNumber () {
          return inMx ? (this.form.collegeNumber !== undefined && this.form.collegeNumber.toString().length >= 5)
          : (this.form.countryId !== SPAIN_COUNTRY_ID ? false : (this.searchIfMedical(this.form.specialityList).find(p => p !== undefined) && this.form.countryId === SPAIN_COUNTRY_ID) ? (this.form.collegeNumber === undefined ? false : this.form.collegeNumber.toString().length === 9) : true)
        },
    searchIfMedical (id) {
     return this.selectedSpeciality.options.map((x, i) => {
        if (x.id === id) return x.medical
      })
    },
    validateState (prop) {
      /* eslint-disable no-unused-vars */
      const { $dirty, $error } = this.$v.form[prop]
      return $dirty ? !$error : null
    },
    builtInOkFn () {
      this.visibleModal = false
      this.$router.go(this.$router.currentRoute)
    },
    validateUrl: function (url) {
      if (url === null || url === '' || url === undefined) {
        return false
      } else if (url.includes('www.')) {
        return /^(ftp|http|https):\/\/(www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})($|\/\S*)$/.test(url.replace('www.', ''))
      } else {
        return /^(ftp|http|https):\/\/(www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})($|\/\S*)$/.test(url)
      }
    },
    validateEmail: function (email) {
      var re = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/
      if (!re.test(email)) {
        return false
      } else {
        return true
      }
    },
    signup: function () {
      const _this = this
      this.resetForm()
      this.dniregistered = false
      this.form.trySubmit = true
      var maleRole = false
      if (this.form.gender === 'H') maleRole = true
      this.form.state.submitted = true
      this.form.state.waiting = true
      if (this.form.nifnumber != null) {
        this.form.dni = this.form.nifnumber
      }
      if (this.formIsValid()) {
      var lng = []
      this.form.selectedLangs.map((x, i) => {
        lng.push(x.id)
      })
      this.form.state.waiting = true
        this.$api.post('/CreateProfessional', {
          ClientReturnUrl: encodeURIComponent(_this.$route.query.returnUrl || (_this.$route.query.ReturnUrl || null)),
          role: 'Profesional',
          male: maleRole,
          female: !maleRole,
          firstName: this.form.name.trim(),
          lastName1: this.form.firstSurname.trim(),
          lastName2: this.form.secondSurname != null ? this.form.secondSurname.trim() : null,
          idCountry: this.form.countryId,
          idProvince: this.form.stateId.id,
          codPromotion: this.form.codPromotion,
          experience: this.form.experienceProfessional,
          university: this.form.university,
          idHowToMeet: this.form.discoveryCheck != null ? this.form.discoveryCheck : 10,
          email: this.form.email.toLowerCase(),
          dni: this.form.dni,
          speciality: inOpenlegal() ? 93 : this.form.specialityList,
          prefix: this.form.prefixCountry,
          provinciaColegiacion: this.form.stateIdCollege.name.es,
          phone: this.form.phoneNumber,
          numColegiado: this.form.collegeNumber,
          web: this.form.urlProfessional,
          languages: lng
          }).then((response) => {
          this.defaultLoginCallback(response)
        }).catch(function () {
          _this.form.state.errors = true
          _this.form.state.waiting = false
          return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: false } })
        })
      } else {
        _this.form.state.waiting = false
      }
    },
    defaultLoginCallback (response) {
      if (response.data) {
        switch (response.data.status) {
          case 200:
              return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: true } })
          case 403:
            this.submitError = response.data.message
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 400:
            this.submitError = this.$t('error-professionalregistered')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 405:
            this.submitError = this.$t('invalidPromotionCode')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          default:
            this.form.state.errors = true
            this.form.state.waiting = false
            break
        }
      } else {
        this.form.state.errors = true
        this.form.state.waiting = false
      }
    },
    checkQueryProvinces: function () {
      if ((this.$route.query.province || this.$route.query.collegeProvince) && this.selectProvince.options.length > 0) {
        const queryProvince = this.$route.query.province.toLowerCase()
        const queryProvinceCollege = this.$route.query.collegeProvince.toLowerCase()
          const matchingProvince = this.selectProvince.options.find(option => {
            const normalizedOptionNameProvince = this.$i18nHelpers.normalize(option.name).toLowerCase()
            return normalizedOptionNameProvince === queryProvince
          })
          const matchingProvinceCollege = this.selectProvince.options.find(option => {
            const normalizedOptionNameProvinceCollege = this.$i18nHelpers.normalize(option.name).toLowerCase()
            return normalizedOptionNameProvinceCollege === queryProvinceCollege
          })
          if (matchingProvince) {
            this.selectProvince.selectedServer = matchingProvince.id
            this.form.stateId = matchingProvince
          }
          if (matchingProvinceCollege) {
            this.selectProvinceCollege.selectedServer = matchingProvinceCollege.id
            this.form.stateIdCollege = matchingProvinceCollege
          }
        }
    },
    resetForm: function () {
      this.form.state.submitted = false
      this.form.state.waiting = false
      this.form.state.unauthorized = false
      this.form.state.errors = false
    },
    touchFields (fields) {
      fields.forEach(field => {
        if (this.$route.query[field]) {
          this.$v.form[field].$touch()
        }
      })
    }
  },
  computed: {
    emailValidation: function () {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted)
    },
    passwordValidation: function () {
      return this.$validators.validate(this.form.password, ['required'], this.form.state.submitted)
    },
		codPromotionIsValid () {
			return (this.form.state.submitted && inOpenlegal()) && this.$validators.validate(this.form.codPromotion, ['required'], this.form.state.submitted)
		}
  },
  async mounted () {
    const fieldsToValidate = ['name', 'firstSurname', 'secondSurname', 'urlProfessional', 'email', 'emailConfirmation']
    this.touchFields(fieldsToValidate)

    if (!inOpenlegal()) {
      await this.callSpecialties()
    }
    if (this.$route.query.discovery && this.selectDiscovery.options.length > 0) {
          const queryDiscovery = this.$route.query.discovery.toLowerCase()
          const matchingDiscovery = this.selectDiscovery.options.find(option => {
            const normalizedOptionNameDiscovery = option.text.toLowerCase()
            return normalizedOptionNameDiscovery === queryDiscovery
          })
          if (matchingDiscovery) {
            this.selectDiscovery.selected = matchingDiscovery.value
          }
    }
    if (this.$route.query.group) {
      this.callChecks()
    }
    languagesRepository.getLanguages().then((response) => {
      this.formSelectLang.options = response.data
      this.formSelectLang.optionsCopy = response.data
      if (this.$route.query.languages && this.formSelectLang.options.length > 0) {
        const queryLanguages = this.$route.query.languages.toLowerCase().split(',')
        const matchingOptions = response.data.filter(option => {
          const normalizedOptionName = this.$i18nHelpers.normalize(option.name).toLowerCase()
          return queryLanguages.includes(normalizedOptionName)
        })
        if (matchingOptions.length > 0) {
          this.formSelectLang.selected = matchingOptions
        }
      }
    })
    await geographyRepository.getCountries().then((response) => {
      this.selectedCountry.options = response.data
      this.selectPrefix.options = response.data
      this.form.countryId = getDefaultCountryId()
      this.form.prefixCountry = getDefaultPhonePrefix()
      if (this.$route.query.country && this.selectedCountry.options.length > 0) {
          const queryCountry = this.$route.query.country.toLowerCase()
          const matchingCountry = response.data.find(option => {
            const normalizedOptionNameCountry = this.$i18nHelpers.normalize(option.name).toLowerCase()
            return normalizedOptionNameCountry === queryCountry
          })
          if (matchingCountry) {
            this.form.countryId = matchingCountry.idCountry
            this.form.prefixCountry = matchingCountry.phonePrefix
          }
        }
				geographyRepository.getStatesByCountry(this.form.countryId).then((response) => {
					this.selectProvince.options = response.data
				})
    })
  }
}
</script>

<style lang="scss" scoped>

.checkbox-codegroup{
  color:$blue;cursor:pointer
}

.checkbox-codegroup:hover{
  color:$blue-clickable-hover;cursor:pointer;text-decoration: underline;
}
.os-card {
  @include desktop {
    padding: 3rem 6rem;
  }
  @include desktop-sm {
    padding: 3rem 6rem;
  }
  @include tablets {
    padding: 3rem 6rem;
  }
  @include mobile {
    padding: 3rem 1rem;
    h3{
      font-size: 1.3rem;
    }
  }
  border-radius: $border-radius !important;
  box-shadow: $custom-shadow;
  margin: {
    bottom: 2rem;
  }
}

.log-in-a{
  color: $blue !important
}
.title-modal{
  font-weight: bold;
  font-size: 1.7rem;
}
  span .vs__selected{
    margin-left: 1%;
    font-size: 0.8rem;    
  }

  .v-select {
    // margin: 2% 0px 2% 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;

  }


  /deep/ #province .vs__selected,
/deep/ #provinceCollege .vs__selected {  left: 0;
  right: 0;
  margin-left: auto !important;
  margin-right: auto !important;
  width: max-content;
}

  .form-group{
    margin: 2% 0px 2% 0px !important;
  }

  div .v-select .vs--unsearchable{
    margin: 0px !important;
  }

  .vs__selected, .vs__search, .vs__search:focus {
  margin-left: 1rem !important;
  
  }

  .v-select .vs--single .vs--unsearchable{
        margin: 0px !important;
  }

  div .mt-3, button, p, fieldset, .v-select, .custom-checkbox, .my-3 {
      margin-top: 0rem !important;
  }

  #lang{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #prefix{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #country{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #province{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }

  #genderForm{
    // display: inline-flex;
    text-align: left !important;
  }

  .genderText{
    float: left;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    padding: 0rem 1rem;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    // margin-right: auto !important;
    // margin-left: auto !important;
  }

  @media (max-width: 1024px) {
    .Body1_OH-sm{
    display:block !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    }
  }



  .headerMenu {
    margin: 22px 133px 0px 4% ;
    // line-height: 2.70 !important;
    // display: block !important;
    // @media (max-width: 1024px) {
    //   margin: auto !important;
    // }
  }

  div  .Body3_rightCol{
      padding-right: 0px !important;
      padding-left: 0px !important;      
  }

  .Body2_OH {
    margin: 5% 0% 0% 12% !important;
}
.Body3_div {
    display: block;
    padding: 8% 0px 8% 10% !important;;
    background-color: #1D1D1E;
    opacity: 87%;
    margin: 0px 0% 0px 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/forms/ProfessionalSignupForm.vue